import { IConfig } from './IConfig';
import * as localConfig from './default.json';

const envConfig: IConfig = JSON.parse(process.env.CONFIG || '{}');

export const config: IConfig = Object.assign({}, localConfig.default, envConfig);
